module.exports = __webpack_public_path__ + "static/media/bg_caption_curves.76386d1e.svg";